import React from "react";
import { ConnectProto } from "@racoon/api";
import { BusinessMetricsChart } from "./BusinessMetricsChart";
import { CustomerActivityChart } from "./CustomerActivityChart";
import { DriversSection } from "./DriversSection";
import { CategoryKey } from "./CategoryChips";
import { DateValue } from "~/shared/lib/analytics-utils";

interface Props {
  startDate: DateValue;
  endDate: DateValue;
  category: CategoryKey;
}

export const AnalyticsCharts: React.FC<Props> = ({ startDate, endDate, category }) => {
  const jobCategory =
    category === "all" ? ConnectProto.JobCategory.UNDEFINED : ConnectProto.JobCategory[category];
  const routeCategory =
    category === "all" ? ConnectProto.RouteCategory.UNDEFINED : ConnectProto.RouteCategory[category];

  return (
    <div className="min-h-[600px] overflow-y-auto md:h-full md:overflow-hidden">
      <div className="grid grid-cols-1 gap-4 h-full md:grid-cols-2 md:grid-rows-1">
        <DriversSection startDate={startDate} endDate={endDate} routeCategory={routeCategory} />

        {/* The two right cards split the column height instead of scrolling it. */}
        <div className="flex flex-col gap-4 md:h-full md:min-h-0">
          <div className="h-[420px] md:h-auto md:min-h-0 md:flex-1">
            <BusinessMetricsChart startDate={startDate} endDate={endDate} jobCategory={jobCategory} />
          </div>
          <div className="h-[420px] md:h-auto md:min-h-0 md:flex-1">
            <CustomerActivityChart startDate={startDate} endDate={endDate} jobCategory={jobCategory} />
          </div>
        </div>
      </div>
    </div>
  );
};
